(function ($) {
  $(window).on("load", function () {
    $(".warmzie-home-hero").addClass("activeHero");
    $(".warmzie-page-banner").addClass("activeBanner");
    $(".featuredBlogSection").addClass("activeBlogs");
    $(".warmzie-whoweare").addClass("activeAbout");
    $(".warmzie-contact-form").addClass("activeContact");
    $(".warmzie-needhelp").addClass("activeNeedhelp");
    $("header.header").addClass("activeMenu");
  });

  //FAQs Tabs
  $(".tab01").each(function () {
    $(this).click(function () {
      const tabID = $(this).attr("data-tab");
      $(".tab01").removeClass("active");
      $(this).addClass("active");

      $(".tabcontent").each(function () {
        const contentID = $(this).attr("data-content");
        if (contentID == tabID) {
          $(".tabcontent").removeClass("active");
          $(this).addClass("active");
        }
      });
    });
  });

  //Questions Tabs
  $(".questions").each(function () {
    $(this).click(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active"); // Remove active if the element already has it
      } else {
        $(".questions").removeClass("active"); // Remove 'active' from all other elements
        $(this).addClass("active"); // Add 'active' to the clicked element
      }
    });
  });

  SmoothScroll({
    // Scrolling Core
    frameRate: 300, // [Hz]
    animationTime: 1000, // [ms]
    stepSize: 70, // [px]

    // Pulse (less tweakable)
    // ratio of "tail" to "acceleration"
    pulseAlgorithm: true,
    pulseScale: 4,
    pulseNormalize: 1,

    // Acceleration
    accelerationDelta: 50, // 50
    accelerationMax: 3, // 3

    // Keyboard Settings
    keyboardSupport: true, // option
    arrowScroll: 50, // [px]

    // Other
    fixedBackground: true,
    excluded: "",
  });

  //Hero slider
  $("#HeroImageSlider").slick({
    infinite: true,
    loop: true,
    slidesToShow: 5,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 4000,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  });

  //Product Slider (Feature)
  $("#FeaturedproductSlider").slick({
    infinite: true,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 1000,
    speed: 3000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  });

  //Testimonials
  $("#testimonialsSlider").slick({
    infinite: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
        },
      },
    ],
  });

  //Mission - About
  $("#missionSlider").slick({
    infinite: true,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 3000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
  });


//Scroll Top 
$(window).scroll(function(){
 var scrollTop = $(window).scrollTop();
  if(scrollTop > 400){
      $('.ScrollToTop').addClass('show');
  }else{
      $('.ScrollToTop').removeClass('show');
  }
});

$('.ScrollToTop').click(function(){
   $('html, body').animate({
     scrollTop: 0
   }, "slow");
});



})(jQuery);
